/**
 * Landing v3 — the posts in the "Thousands post about us" carousel, in order.
 *
 * GENERATED data, captured 2026-09-23: author, handle and caption from
 * TikTok's oEmbed (the photo post answers only under its `/video/` URL form),
 * likes and comments read from each public post page, the Instagram reel from
 * its page's Open Graph tags. Posters are self-hosted at
 * `public/assets/landing/tiktok/<id>.jpg` (585×1040) because the platforms'
 * thumbnail URLs are signed and expire. To refresh: re-run the capture in the
 * session scratchpad recipe (curl oEmbed + page with a browser UA), replace the
 * posters, bump `POSTS_CAPTURED_AT`.
 */
export type LandingPost = {
  /** TikTok video id, or `ig-<shortcode>` for an Instagram reel. */
  id: string;
  platform: 'tiktok' | 'instagram';
  /** TikTok distinguishes photo carousels from videos in the URL. */
  kind: 'video' | 'photo';
  handle: string;
  author: string;
  caption: string;
  likes: number;
  comments: number;
  href: string;
};

/** When the counts and posters were captured. */
export const POSTS_CAPTURED_AT = '2026-09-23';

export const LANDING_POSTS: LandingPost[] = [
  {
    id: '7655627825352887574',
    platform: 'tiktok',
    kind: 'video',
    handle: 'notes.by.eliii',
    author: 'notes.by.eliii 🩵',
    caption: '#uni #examenes #flashka #bachillerato #estudio',
    likes: 209700,
    comments: 3508,
    href: 'https://www.tiktok.com/@notes.by.eliii/video/7655627825352887574',
  },
  {
    id: '7604551937354255619',
    platform: 'tiktok',
    kind: 'photo',
    handle: 'soyale.biomedica',
    author: 'Alejandra',
    caption:
      'apps que son super útiles para carreras de la salud #apps #estudiantedemedicina #medicina #enfermeria #uni',
    likes: 145700,
    comments: 150,
    href: 'https://www.tiktok.com/@soyale.biomedica/photo/7604551937354255619',
  },
  {
    id: '7680919108740713760',
    platform: 'tiktok',
    kind: 'video',
    handle: 'ambredroit',
    author: 'AMBRE',
    caption: '#revisions #studytok #examseason #rentree #droit',
    likes: 142700,
    comments: 83,
    href: 'https://www.tiktok.com/@ambredroit/video/7680919108740713760',
  },
  {
    id: '7595939893793017110',
    platform: 'tiktok',
    kind: 'video',
    handle: 'medels0',
    author: 'med.els',
    caption:
      'Ecco il mio metodo di studio (video lungo scusate)❤️ #medstudent #media #metodo #medicina #esami adv',
    likes: 80000,
    comments: 313,
    href: 'https://www.tiktok.com/@medels0/video/7595939893793017110',
  },
  {
    id: '7613407749413604610',
    platform: 'tiktok',
    kind: 'video',
    handle: 'inessvet_',
    author: '🤍🐾🩺',
    caption:
      'El mejor método de estudio para carreras de salud 💯  #tipsdeestudio #estudiantesdesalud #estudiantesdemedicina #salud #hazmeviral',
    likes: 126800,
    comments: 153,
    href: 'https://www.tiktok.com/@inessvet_/video/7613407749413604610',
  },
  {
    id: '7598648043327524118',
    platform: 'tiktok',
    kind: 'video',
    handle: 'miri21_2',
    author: 'Miriii',
    caption: 'INCREÍBLE LOL #studytok #uni #examenes #memorizar #ad',
    likes: 56400,
    comments: 43,
    href: 'https://www.tiktok.com/@miri21_2/video/7598648043327524118',
  },
  {
    id: '7655258597454056737',
    platform: 'tiktok',
    kind: 'video',
    handle: 'clea.lanciii',
    author: 'ＣＬＥ́Ａ',
    caption: '#baccalaureat #fakesituation #brevet #oralexam #grandoral',
    likes: 30300,
    comments: 50,
    href: 'https://www.tiktok.com/@clea.lanciii/video/7655258597454056737',
  },
  {
    id: '7649547719505120534',
    platform: 'tiktok',
    kind: 'video',
    handle: 'alejandromeseg',
    author: 'Alejandromeseg',
    caption:
      'La mejor técnica para sacar un 10 en FARMACOLOGIA  #farmacologia #examen #estudiantes #estudiantedemedicina #uni',
    likes: 37000,
    comments: 60,
    href: 'https://www.tiktok.com/@alejandromeseg/video/7649547719505120534',
  },
  {
    id: 'ig-DdUju09zVlF',
    platform: 'instagram',
    kind: 'video',
    handle: 'notes.by.eliii',
    author: 'Notes by Eliii',
    caption: '#universidad #apps #anatomia #flashkapartner #estudio',
    likes: 60000,
    comments: 20,
    href: 'https://www.instagram.com/reel/DdUju09zVlF/',
  },
  {
    id: '7683125471046913313',
    platform: 'tiktok',
    kind: 'video',
    handle: 'reussirkine',
    author: 'Astuces études de santé',
    caption:
      'Meilleure app de révision ! C’est tellement plus efficace cette méthode !  *t’a conseillé #revision #medecine #app #ia #flashkaia',
    likes: 32000,
    comments: 54,
    href: 'https://www.tiktok.com/@reussirkine/video/7683125471046913313',
  },
  {
    id: '7601538541507611926',
    platform: 'tiktok',
    kind: 'video',
    handle: 'notes.by.eliii',
    author: 'notes.by.eliii 🩵',
    caption:
      'lo que realmente marca la diferencia es el método de estudio y la IA que utilices ##estudio##uni##studytok##flashka##bachillerato',
    likes: 7125,
    comments: 123,
    href: 'https://www.tiktok.com/@notes.by.eliii/video/7601538541507611926',
  },
  {
    id: '7650596763375635734',
    platform: 'tiktok',
    kind: 'video',
    handle: 'notes.by.eliii',
    author: 'notes.by.eliii 🩵',
    caption: '#uni #flashka #examenes #bachillerato',
    likes: 331000,
    comments: 970,
    href: 'https://www.tiktok.com/@notes.by.eliii/video/7650596763375635734',
  },
];
